import { useUnreadNotificationRefresh } from "components/UnreadNotificationsRefresh/useUnreadNotificationsRefresh"

const UnreadNotificationsRefresh = () => {
    useUnreadNotificationRefresh()
    return null
}

export default UnreadNotificationsRefresh
